import {isValidElement} from 'react'

export const findFirstTextChild = (parent: React.ReactNode): string | undefined => {
  if (typeof parent === 'string') {
    return parent
  }
  if (!isValidElement(parent)) {
    return undefined
  }

  const {children} = parent.props as {children?: React.ReactNode}

  if (typeof children === 'string') {
    return children
  }

  if (Array.isArray(children)) {
    return findFirstTextChild(children[0])
  }

  return undefined
}
